// AXIOS SETUP
import _ from 'lodash'
import axios from "axios"
import Router from '@/router/index.js'

import { store } from "@/store/store-init"
import { mixedMSG } from "@/utils.js"

const GeneralVersion = '1.15.0'; // Remoción de modal de detalle si la vista no está configurada para recetas.

let api = 'prod', // [prod|docker|alpha|dev|ngrok]
	apiURI,
	apiExpedientesURI,
	apiURIMain;

switch (api) {
	case 'docker': // DEV
		apiURI = 'http://localhost:8001/supereasyMX-api-dev/';
		apiExpedientesURI = 'http://localhost:8080/';
		break;
	case 'alpha':	 // TEST-FLIGHT 
		apiURI = 'https://api.supereasy.mx/alpha/';
		apiExpedientesURI = 'https://expediente.supereasy.mx/';
		break;
	case 'dev':
		apiURI = 'https://api.supereasy.mx/adev/';
		apiExpedientesURI = 'https://expediente.supereasy.mx/';
		break;
	case 'prod': // (PAYPAL-WEBHOOK)
		apiURI = 'https://api.supereasy.mx/prod/';
		apiExpedientesURI = 'https://expediente.supereasy.mx/';
		break;
	case 'ngrok':
		apiExpedientesURI = 'https://expediente.supereasy.mx/';
		apiURI = 'https://d77b3f9801a0.ngrok.app/supereasyMX-api-dev/';
		break;
	default:
		apiURI = 'https://api.supereasy.mx/api-main/';
		apiExpedientesURI = 'https://expediente.supereasy.mx/';
		break;

}

apiURIMain = apiURI + 'index.php?r=';

axios.defaults.baseURL = apiURIMain + 'main';
axios.defaults.maediaImageRender = apiURIMain + 'img/render/';
axios.defaults.publicURL = 'http://supereasy.mx/';
axios.defaults.timeout = 30000

axios.interceptors.request.use((config) => {
	// Do something before request is sent
	config.headers['Content-Type'] = 'text/plain';
	if (store.getters.authToken)
		config.headers['auth-token'] = store.getters.authToken;
	return config;
}, (error) => {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {

	// Do something with response data
	let processing = response.data;

	if (!_.isObject(processing))
		throw ('Error de servidor, no se pudo procesar la respuesta.');

	mixedMSG(processing.status, processing.msg, processing.class);

	// FORCE LOGOUT
	if (!processing.status && _.isObject(processing.data) && processing.data.force_logout) {
		console.log('Force!', processing, store)
		store.commit('accountClean')
		Router.replace('/')
		// store.
	}

	return processing;
}, (error) => {
	mixedMSG(false, error, 'error');
	return Promise.reject(error);
});

export {
	GeneralVersion,
	apiURI,
	apiExpedientesURI,
	apiURIMain
}